const pub = { kind: 'public' };
const session = { kind: 'session' };
const svc = (...anyOf) => ({ kind: 'service', anyOf });
export const API_ROUTES = {
    // Auth (unified-access.md section 3)
    authLaunch: { method: 'POST', path: '/auth/launch', access: pub, body: 'json', response: 'json' },
    authMe: { method: 'GET', path: '/auth/me', access: session, response: 'json' },
    authLogout: { method: 'POST', path: '/auth/logout', access: pub, response: 'empty' },
    branches: { method: 'GET', path: '/branches', access: session, response: 'json' },
    // Users and groups (as in Customers)
    usersList: { method: 'GET', path: '/users', access: svc('USER_LIST'), response: 'json' },
    usersEmployeeLookup: {
        method: 'GET',
        path: '/users/employee-lookup',
        access: svc('USER_CREATE'),
        response: 'json',
    },
    usersGet: { method: 'GET', path: '/users/:id', access: svc('USER_VIEW'), response: 'json' },
    usersCreate: {
        method: 'POST',
        path: '/users',
        access: svc('USER_CREATE'),
        body: 'json',
        response: 'json',
    },
    usersUpdate: {
        method: 'PATCH',
        path: '/users/:id',
        access: svc('USER_UPDATE'),
        body: 'json',
        response: 'json',
    },
    usersChangeStatus: {
        method: 'PUT',
        path: '/users/:id/status',
        access: svc('USER_CHANGE_STATUS'),
        body: 'json',
        response: 'json',
    },
    usersResetPassword: {
        method: 'POST',
        path: '/users/:id/reset-password',
        access: svc('USER_RESET_PASSWORD'),
        response: 'json',
    },
    usersDelete: {
        method: 'DELETE',
        path: '/users/:id',
        access: svc('USER_DELETE'),
        response: 'json',
    },
    groupsList: { method: 'GET', path: '/groups', access: svc('GROUP_LIST'), response: 'json' },
    servicesTree: { method: 'GET', path: '/services', access: svc('GROUP_LIST'), response: 'json' },
    groupsGet: { method: 'GET', path: '/groups/:id', access: svc('GROUP_VIEW'), response: 'json' },
    groupsCreate: {
        method: 'POST',
        path: '/groups',
        access: svc('GROUP_CREATE'),
        body: 'json',
        response: 'json',
    },
    groupsUpdate: {
        method: 'PATCH',
        path: '/groups/:id',
        access: svc('GROUP_UPDATE'),
        body: 'json',
        response: 'json',
    },
    groupsChangeStatus: {
        method: 'PUT',
        path: '/groups/:id/status',
        access: svc('GROUP_CHANGE_STATUS'),
        body: 'json',
        response: 'json',
    },
    groupsSetServices: {
        method: 'PUT',
        path: '/groups/:id/services',
        access: svc('GROUP_SERVICE_MANAGE'),
        body: 'json',
        response: 'json',
    },
    groupsDelete: {
        method: 'DELETE',
        path: '/groups/:id',
        access: svc('GROUP_DELETE'),
        response: 'json',
    },
    // Currencies (section 10)
    currenciesList: {
        method: 'GET',
        path: '/currencies',
        access: svc('CURRENCY_LIST'),
        response: 'json',
    },
    currenciesOptions: {
        method: 'GET',
        path: '/currencies/options',
        access: session,
        response: 'json',
    },
    currenciesGet: {
        method: 'GET',
        path: '/currencies/:id',
        access: svc('CURRENCY_VIEW'),
        response: 'json',
    },
    currenciesCreate: {
        method: 'POST',
        path: '/currencies',
        access: svc('CURRENCY_CREATE'),
        body: 'json',
        response: 'json',
    },
    currenciesUpdate: {
        method: 'PATCH',
        path: '/currencies/:id',
        access: svc('CURRENCY_UPDATE'),
        body: 'json',
        response: 'json',
    },
    currenciesChangeStatus: {
        method: 'PUT',
        path: '/currencies/:id/status',
        access: svc('CURRENCY_CHANGE_STATUS'),
        body: 'json',
        response: 'json',
    },
    // Settings (section 10)
    settingsGet: { method: 'GET', path: '/settings', access: svc('SETTINGS_VIEW'), response: 'json' },
    settingsUpdate: {
        method: 'PATCH',
        path: '/settings',
        access: svc('SETTINGS_UPDATE'),
        body: 'json',
        response: 'json',
    },
    // Tablets of the session branch, from the shared tablet service (section 6)
    tabletsOptions: {
        method: 'GET',
        path: '/tablets/options',
        access: svc('DEPOSIT_CREATE', 'DEPOSIT_DELIVER', 'DEPOSIT_RETURN', 'DEPOSIT_UPDATE'),
        response: 'json',
    },
    // Employee side of tablet tasks
    tasksGet: {
        method: 'GET',
        path: '/tablet-tasks/:id',
        access: svc('DEPOSIT_CREATE', 'DEPOSIT_DELIVER', 'DEPOSIT_RETURN', 'DEPOSIT_UPDATE'),
        response: 'json',
    },
    tasksResend: {
        method: 'POST',
        path: '/tablet-tasks/:id/resend',
        access: svc('DEPOSIT_CREATE', 'DEPOSIT_DELIVER', 'DEPOSIT_RETURN', 'DEPOSIT_UPDATE'),
        body: 'json',
        response: 'json',
    },
    tasksCancel: {
        method: 'POST',
        path: '/tablet-tasks/:id/cancel',
        access: svc('DEPOSIT_CREATE', 'DEPOSIT_DELIVER', 'DEPOSIT_RETURN', 'DEPOSIT_UPDATE'),
        response: 'json',
    },
    tasksStartScan: {
        method: 'POST',
        path: '/tablet-tasks/scan',
        access: svc('DEPOSIT_DELIVER', 'DEPOSIT_RETURN'),
        body: 'json',
        response: 'json',
    },
    // Deposit (section 4)
    draftsCreate: {
        method: 'POST',
        path: '/deposits/drafts',
        access: svc('DEPOSIT_CREATE'),
        body: 'json',
        response: 'json',
    },
    draftsGet: {
        method: 'GET',
        path: '/deposits/drafts/:id',
        access: svc('DEPOSIT_CREATE'),
        response: 'json',
    },
    draftsUpdate: {
        method: 'PATCH',
        path: '/deposits/drafts/:id',
        access: svc('DEPOSIT_CREATE'),
        body: 'json',
        response: 'json',
    },
    draftsSendToTablet: {
        method: 'POST',
        path: '/deposits/drafts/:id/send-to-tablet',
        access: svc('DEPOSIT_CREATE'),
        body: 'json',
        response: 'json',
    },
    draftsDiscard: {
        method: 'DELETE',
        path: '/deposits/drafts/:id',
        access: svc('DEPOSIT_CREATE'),
        response: 'empty',
    },
    draftsConfirm: {
        method: 'POST',
        path: '/deposits/drafts/:id/confirm',
        access: svc('DEPOSIT_CREATE'),
        idempotent: true,
        body: 'json',
        response: 'json',
    },
    // WhatsApp phone verification, relayed to Customers (customers.md section 10)
    /** Whether the switch of إعدادات الأمانات is on, for the screens that save a phone. */
    phoneVerificationsSetting: {
        method: 'GET',
        path: '/phone-verifications/setting',
        access: svc('DEPOSIT_CREATE', 'DEPOSIT_DELIVER', 'DEPOSIT_UPDATE'),
        response: 'json',
    },
    phoneVerificationsRequest: {
        method: 'POST',
        path: '/phone-verifications',
        access: svc('DEPOSIT_CREATE', 'DEPOSIT_DELIVER', 'DEPOSIT_UPDATE'),
        idempotent: true,
        body: 'json',
        response: 'json',
    },
    phoneVerificationsResend: {
        method: 'POST',
        path: '/phone-verifications/:id/resend',
        access: svc('DEPOSIT_CREATE', 'DEPOSIT_DELIVER', 'DEPOSIT_UPDATE'),
        idempotent: true,
        response: 'json',
    },
    phoneVerificationsVerify: {
        method: 'POST',
        path: '/phone-verifications/:id/verify',
        access: svc('DEPOSIT_CREATE', 'DEPOSIT_DELIVER', 'DEPOSIT_UPDATE'),
        body: 'json',
        response: 'json',
    },
    phoneVerificationsGet: {
        method: 'GET',
        path: '/phone-verifications/:id',
        access: svc('DEPOSIT_CREATE', 'DEPOSIT_DELIVER', 'DEPOSIT_UPDATE'),
        response: 'json',
    },
    // List, details, exports (section 8)
    depositsList: { method: 'GET', path: '/deposits', access: svc('DEPOSIT_LIST'), response: 'json' },
    depositsExport: {
        method: 'GET',
        path: '/deposits/export',
        access: svc('DEPOSIT_EXPORT'),
        response: 'file',
    },
    /** Employees who deposited or delivered in the caller's branches (list and report filters). */
    depositsEmployeeOptions: {
        method: 'GET',
        path: '/deposits/employee-options',
        access: svc('DEPOSIT_LIST', 'REPORT_VIEW'),
        response: 'json',
    },
    depositsGet: {
        method: 'GET',
        path: '/deposits/:id',
        access: svc('DEPOSIT_VIEW'),
        response: 'json',
    },
    depositsReceipt: {
        method: 'GET',
        path: '/deposits/:id/receipt',
        access: svc('DEPOSIT_CREATE', 'DEPOSIT_REPRINT'),
        response: 'json',
    },
    depositsRecordPrint: {
        method: 'POST',
        path: '/deposits/:id/prints',
        access: svc('DEPOSIT_CREATE', 'DEPOSIT_REPRINT'),
        body: 'json',
        response: 'json',
    },
    depositsResendMessage: {
        method: 'POST',
        path: '/deposits/:id/messages/:messageId/resend',
        access: svc('DEPOSIT_RESEND'),
        response: 'json',
    },
    depositsEdit: {
        method: 'PATCH',
        path: '/deposits/:id',
        access: svc('DEPOSIT_UPDATE'),
        idempotent: true,
        body: 'json',
        response: 'json',
    },
    depositsUploadEditAttachment: {
        method: 'POST',
        path: '/deposits/:id/edit-attachments',
        access: svc('DEPOSIT_UPDATE'),
        body: 'multipart',
        response: 'json',
    },
    depositsResign: {
        method: 'POST',
        path: '/deposits/:id/resign',
        access: svc('DEPOSIT_UPDATE'),
        body: 'json',
        response: 'json',
    },
    depositsCancel: {
        method: 'POST',
        path: '/deposits/:id/cancel',
        access: svc('DEPOSIT_CANCEL'),
        idempotent: true,
        body: 'json',
        response: 'json',
    },
    // Delivery, return, referral (section 5)
    deliveryLookup: {
        method: 'GET',
        path: '/deliveries/lookup',
        access: svc('DEPOSIT_DELIVER', 'DEPOSIT_RETURN'),
        response: 'json',
    },
    depositsRecipientCapture: {
        method: 'POST',
        path: '/deposits/:id/recipient-capture',
        access: svc('DEPOSIT_DELIVER', 'DEPOSIT_RETURN'),
        body: 'json',
        response: 'json',
    },
    depositsDeliver: {
        method: 'POST',
        path: '/deposits/:id/deliver',
        access: svc('DEPOSIT_DELIVER'),
        idempotent: true,
        body: 'json',
        response: 'json',
    },
    depositsReturn: {
        method: 'POST',
        path: '/deposits/:id/return',
        access: svc('DEPOSIT_RETURN'),
        idempotent: true,
        body: 'json',
        response: 'json',
    },
    depositsRefer: {
        method: 'POST',
        path: '/deposits/:id/referrals',
        access: svc('DEPOSIT_DELIVER'),
        idempotent: true,
        body: 'json',
        response: 'json',
    },
    depositsReviewReferral: {
        method: 'POST',
        path: '/deposits/:id/referrals/:referralId/review',
        access: svc('DEPOSIT_REFERRAL_REVIEW'),
        idempotent: true,
        body: 'json',
        response: 'json',
    },
    // Files (section 12): never public
    filesSignature: {
        method: 'GET',
        path: '/files/signatures/:id',
        access: svc('DEPOSIT_VIEW'),
        response: 'file',
    },
    filesDocumentPhoto: {
        method: 'GET',
        path: '/files/document-photos/:id',
        access: svc('DEPOSIT_DOCUMENT_VIEW'),
        response: 'file',
    },
    filesEditAttachment: {
        method: 'GET',
        path: '/files/edit-attachments/:id',
        access: svc('DEPOSIT_VIEW'),
        response: 'file',
    },
    // Reports (section 9)
    reportsHeld: {
        method: 'GET',
        path: '/reports/held',
        access: svc('REPORT_VIEW'),
        response: 'json',
    },
    reportsDelivered: {
        method: 'GET',
        path: '/reports/delivered',
        access: svc('REPORT_VIEW'),
        response: 'json',
    },
    reportsDetailed: {
        method: 'GET',
        path: '/reports/detailed',
        access: svc('REPORT_VIEW'),
        response: 'json',
    },
    reportsByCustomer: {
        method: 'GET',
        path: '/reports/by-customer',
        access: svc('REPORT_VIEW'),
        response: 'json',
    },
    reportsByEmployee: {
        method: 'GET',
        path: '/reports/by-employee',
        access: svc('REPORT_VIEW'),
        response: 'json',
    },
    reportsExport: {
        method: 'GET',
        path: '/reports/:kind/export',
        access: svc('REPORT_EXPORT'),
        response: 'file',
    },
};
/** Replaces `:param` segments; values are URI-encoded. */
export function buildApiPath(path, params = {}) {
    return path.replace(/:([A-Za-z]+)/g, (_match, name) => {
        const value = params[name];
        if (value === undefined)
            throw new Error(`missing path parameter ${name}`);
        return encodeURIComponent(value);
    });
}
//# sourceMappingURL=routes.js.map